import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { getIsAuthenticated } from '../../selectors/user';
import { setNewAnswerFormOpen } from '../../actions/newAnswer/openFormActions';
import { requestAuthentication } from '../../actions/authentication';
import { ButtonLink } from '../../components/ButtonLink';
import { TAnswerTarget } from '../../types/answers';

interface INewAnswerButtonContainerProps {
  type: TAnswerTarget;
  targetId: string;
}

export const NewAnswerButtonContainer = ({ targetId, type }: INewAnswerButtonContainerProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setNewAnswerFormOpenByReviewId = React.useCallback(() => {
    return setNewAnswerFormOpen({ id: targetId, type });
  }, [targetId, type]);

  const onOpen = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setNewAnswerFormOpenByReviewId());
    } else {
      dispatch(requestAuthentication({ onSuccess: setNewAnswerFormOpenByReviewId }));
    }
  }, []);

  return (
    <>
      <Responsive desktop tablet>
        <ButtonLink onClick={onOpen}>Ответить</ButtonLink>
      </Responsive>

      <Responsive phone>
        <ButtonLink onClick={onOpen}>Ответить</ButtonLink>
      </Responsive>
    </>
  );
};
